import React, { useRef } from "react";
import { Carousel } from "antd";
import { Modal } from "@networkraildigitalfactory/components";
import { Bell } from "phosphor-react";
import { useUsers } from "../../../hooks/useAPI";
import WhatsNew from "../../../assets/CarouselModal/WhatsNew/WhatsNew.png";
import Notifications from "../../../assets/CarouselModal/WhatsNew/Notifications.png";
import Improving from "../../../assets/CarouselModal/WhatsNew/Improving.png";
import Feedback from "../../../assets/CarouselModal/Onboarding/Feedback.png";
import Screen from "./Screen";
import styles from "./CarouselModal.module.css";
import "./AntdCarousel.css";
import useDisableScroll from "../../../hooks/useDisableScroll";

const WhatsNewModal = (props) => {
  const {
    user,
    updateUser,
    isSecondScreen,
    setIsSecondScreen,
    isWhatsNewModalOpen,
    setIsWhatsNewModalOpen,
  } = props;
  const carousel = useRef(null);

  const setActiveScreen = () => {
    setIsSecondScreen(!isSecondScreen);
  };

  const next = () => {
    setIsSecondScreen(true);
    carousel.current.next();
  };

  const prev = () => {
    setIsSecondScreen(false);
    carousel.current.prev();
  };

  const { email } = user || "";

  const [, executeAction] = useUsers(
    {
      url: email,
      method: "PUT",
    },
    { manual: true }
  );

  const getStarted = async () => {
    const data = {
      ...user,
      hasViewedWhatsNew: true,
    };
    try {
      const latestUserResp = await executeAction({ data });
      updateUser(latestUserResp.data);
      setIsWhatsNewModalOpen(false);
    } catch (e) {
      console.error(e);
    }
  };
  useDisableScroll(isWhatsNewModalOpen);

  return (
    <Modal
      style={{ maxWidth: "90%", width: "625px", position: "fixed" }}
      onClose={getStarted}
      hideControls
      clickBackdropToDismiss={isSecondScreen}
      show={isWhatsNewModalOpen}
    >
      <Carousel ref={carousel} className={styles.CarouselModal} afterChange={setActiveScreen}>
        <Screen
          firstScreen
          imgSrc={WhatsNew}
          imgAlt="what's new"
          heading="We’ve made some changes"
          bodyText={[
            {
              text: "Since you last visited, some things have changed.",
              style: { lineHeight: "22px", margin: "16px 70px 20px 70px" },
            },
            {
              text: "Click ‘Next’ to see some new features...",
              style: { lineHeight: "22px", margin: "16px 70px 20px 70px" },
            },
          ]}
          onButtonClick={next}
        />
        <Screen
          imgSrc={Notifications}
          imgAlt="Notifications"
          heading="Notifications"
          bodyText={[
            {
              text:
                "You can now view your notifications on iPerform by selecting the Notifications icon.",
              style: { lineHeight: "22px", margin: "16px 70px 10px 70px" },
            },
            {
              image: <Bell className={styles.withBorder} color="rgba(55,81,157, 1)" size={32} />,
            },
            {
              text:
                "This means that you will no longer receive lengthy and confusing Activity Reports!",
              style: { lineHeight: "22px", margin: "10px 70px 15px 70px" },
            },
          ]}
          prev={prev}
          onButtonClick={next}
        />
        <Screen
          imgSrc={Improving}
          imgAlt="Improving iPerform"
          heading="Improving iPerform"
          bodyText={[
            {
              text:
                "Off the back of user feedback, we have changed the way we load information on iPerform, ensuring you have the most up-to-date information, without causing issues when refreshing.",
              style: { lineHeight: "22px", margin: "8px 70px 8px 70px" },
            },
            {
              text:
                "To view other changes we have made as a direct result of user feedback, click ",
              link: (
                <a
                  className={styles.privacyStatementLink}
                  // RSIT is an old name of the function. Now it is DDaT
                  href="https://networkrail.sharepoint.com/sites/RSIT2/SitePages/IT-colleagues-only/Supporting-Performance.aspx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here.
                </a>
              ),
              style: { lineHeight: "22px", margin: "8px 70px 8px 70px" },
            },
          ]}
          prev={prev}
          onButtonClick={next}
        />
        <Screen
          lastScreen
          imgSrc={Feedback}
          imgAlt="feedback"
          heading="We need your feedback!"
          bodyText={[
            {
              text:
                "We want to make sure iPerform works for you as users, which is why we’d love to hear your feedback via our survey.",
              style: { lineHeight: "22px", margin: "8px 70px 8px 70px" },
            },
            {
              text:
                "We cannot build a tool that works for you, without you, so thank you for your help!",
              style: { lineHeight: "22px", margin: "8px 70px 8px 70px" },
            },
            {
              text:
                "You can access this feedback form any time from the About page, or by clicking ",
              link: (
                <a
                  className={styles.privacyStatementLink}
                  href="https://forms.office.com/Pages/ResponsePage.aspx?id=4cMswn9dTU--A9WhWMyUCUiXVSSmgJtOrhA8lgFoOyJUME5XVVRaWE9ZMkFaRDFUSkMxOEM2NEFMTS4u"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here.
                </a>
              ),
              style: { lineHeight: "22px", margin: "8px 70px 8px 70px" },
            },
          ]}
          prev={prev}
          onButtonClick={getStarted}
        />
      </Carousel>
    </Modal>
  );
};

export default WhatsNewModal;
